import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

// Your Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBPphPgR5ou7Ma9V5w-H7OaonTD4rfHId0",
  authDomain: "familybibleapp.firebaseapp.com",
  projectId: "familybibleapp",
  storageBucket: "familybibleapp.firebasestorage.app",
  messagingSenderId: "720862389064",
  appId: "1:720862389064:web:362cc5b0b28c2a1d30097d",
  measurementId: "G-547B6634Y4"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);

export default app; 